import { BaseItem } from './common.model';

export enum LicenseStatus {
  New = 0,
  Active = 1,
  Expired = 2,
}

export interface BaseClientItem extends BaseItem {
  contractId: string,
  licenseTypeUid: string;
  licenseTypeName: string;
  totalLicenses: number;
  users: number;
  status: LicenseStatus;
  statusName: string;
}

export interface ServerClientItem extends BaseClientItem {
  licenseStartDate: string;
  licenseEndDate: string;
}

export interface ClientItem extends BaseClientItem {
  licenseStartDate: Date;
  licenseEndDate: Date;
}

export interface ClientLicense extends BaseItem {
  userLimit: boolean;
  timeLimit: boolean;
  interactionsLimit: boolean;
  personal: boolean;
}

export interface BaseClientForm extends BaseItem {
  status?: LicenseStatus;
  settings?: ClientSetting[];
}

export interface ServerClientForm extends BaseClientForm {
  license: LicenseWithTypedDate<string>;
}

export interface ClientForm extends BaseClientForm {
  license: LicenseWithTypedDate<Date>;
  logoUid?: string;
  logoOriginalUid?: string;
  remainingBaseLicenses?: number;
  remainingLicenses?: number;
  contractId?: string;
  mcpAccessMode?: McpAccessMode;
}

export enum McpAccessMode {
  AllUsers = 'AllUsers',
  SelectedUsers = 'SelectedUsers',
}

export enum McpAssignmentFilter {
  Assigned = 'Assigned',
  NotAssigned = 'NotAssigned',
}

export enum McpAccessFilter {
  Enabled = 'Enabled',
  NotGranted = 'NotGranted',
}

export type StringOrDate = string | Date;

export interface LicenseWithTypedDate<T extends StringOrDate> {
  typeUid: string;
  licensedUsers?: number;
  startDate: T;
  endDate: T;
}

export interface ClientOption {
  clientUid: string;
  clientName: string;
  users: UserItem[];
}

export interface UserItem {
  userUid: string;
  userName: string;
}

export interface ClientFeature {
  code: ClientFeatureCode;
  name: string;
  enabled: boolean;
}

export enum ClientFeatureCode {
  Pursuit = 'PURSUIT',
  CompanyBenchmarkJourney = 'COMPANY_BENCHMARK_JOURNEY',
  BenchmarkOperationalPerformanceJourney = 'BENEFITS_FROM_INITIATIVES_JOURNEY',
  AIChat = 'AI_CHAT',
  FinlisticsAiPayedTier = 'FINLISTICS_AI_PAYED_TIER',
  ReportsPreview = 'REPORTS_PREVIEW',
  SolutionsAiIngest = 'SOLUTIONS_AI_INGEST',
}

export interface ClientSetting {
  code: ClientSettingCode;
  value?: string;
}

export enum ClientSettingCode {
  ImprovementDecimalPlaces = 'IMPROVEMENT_DECIMAL_PLACES',
  DisplayCustomLogo = 'DISPLAY_CUSTOM_LOGO',
  AccountPlanTerm = 'ACCOUNT_PLAN_TERM',
  AccountPlanCreateDescription = 'ACCOUNT_PLAN_CREATE_DESCRIPTION',
  RoiExpressCosts = 'ROI_EXPRESS_COSTS',
  FinlisticsAiFreeTierWarningThreshold = 'FINLISTICS_AI_FREE_TIER_WARNING_THRESHOLD',
  FinlisticsAiTierNotificationEmails = 'FINLISTICS_AI_TIER_NOTIFICATION_EMAILS',
  FinlisticsAiFreeTierExceededMessage = 'FINLISTICS_AI_FREE_TIER_EXCEEDED_MESSAGE',
}

export interface ClientUserData {
  clientUid: string;
  name: string;
  email: string;
  roleUid: string;
  status?: number;
  statusName?: string;
  invite: boolean;
  mcpAccess?: McpAccessState;
}

export interface McpAccessState {
  direct: boolean;
  inherited?: boolean;
  effective: boolean;
}
